import React from 'react';
import { formatInstrument, rootSymbol } from '../../utils/instrument';

interface InstrumentCellProps {
  symbol: string | null | undefined;
  className?: string;
}

// Hover-only tooltip on instrument cells: shows the root symbol on hover.
// Uses Tailwind group/group-hover, not the browser-native `title` attribute.
export function InstrumentCell({ symbol, className = '' }: InstrumentCellProps) {
  if (!symbol) return <span className={className}>--</span>;
  return (
    <span className={`relative group cursor-default ${className}`}>
      {formatInstrument(symbol)}
      <span
        className="hidden group-hover:block absolute z-20 bottom-full left-0 mb-1 bg-gray-800 text-xs text-white px-2 py-1 rounded whitespace-nowrap shadow-lg pointer-events-none"
      >
        {rootSymbol(symbol)}
      </span>
    </span>
  );
}
